export const TABLE_COLUMNS = [
  { id: "id", label: "ID", sortable: true },
  { id: "name", label: "Name", sortable: true },
  { id: "date", label: "Date", sortable: true },
  { id: "modality", label: "Modality", sortable: false },
  { id: "status", label: "Status", sortable: true },
];

export const TABLE_COLUMNS_TEST = [
  { id: "userId", label: "User ID", sortable: true },
  { id: "id", label: "ID", sortable: true },
  { id: "title", label: "Title", sortable: false },
  { id: "completed", label: "Completed", sortable: true },
];

export const BROWSER_COLUMNS = [
  { id: "status", label: "Status", sortable: true },
  { id: "studyDate", label: "Study Date", sortable: true },
  { id: "studyDescription", label: "Description", sortable: false },
  { id: "referringPhysicianName", label: "Referring Physician", sortable: true },
  { id: "patientId", label: "Patient ID", sortable: true },
  { id: "patientName", label: "Patient Name", sortable: true },
  { id: "patientBirthdate", label: "Birth Date", sortable: true },
];

export const DICOM_TAG_COLUMNS = [
  { id: "tag", label: "Tag", sortable: false},
  { id: "description", label: "Description", sortable: false},
  { id: "value", label: "Value", sortable: false}
]

// Import from PACS Modal Column들
export const IMPORT_PACS_STUDY_COLUMN = [
  // { id: "status", label: "Status", sortable: false},
  { id: "patientID", label: "Patient ID", sortable: false},
  { id: "patientName", label: "Patient Name", sortable: false},
  { id: "patientSex", label: "Patient Sex", sortable: false},
  { id: "patientBirthDate", label: "Birth Date", sortable: false},
  { id: "studyDate", label: "Study Date", sortable: false},
  // { id: "studyUID", label: "Study UID", sortable: false},
  { id: "studyID", label: "Study ID", sortable: false},
  { id: "accessionNumber", label: "Accession Number", sortable: false},
  { id: "referringPhysicianName", label: "Referring Physician", sortable: false},
]

export const IMPORT_PACS_SERIES_COLUMN = [
  {id: "numberOfSeriesRelatedInstances", label: "# images", sortable: false},
  {id: "modality", label: "Modality", sortable: false},
  {id: "patientID", label: "Patient ID", sortable: false},
  {id: "patientName", label: "Patient Name", sortable: false},
  {id: "seriesDate", label: "Series Date", sortable: false},
  {id: "seriesDesc", label: "Description", sortable: false},
  // {id: "seriesUID", label: "Series UID", sortable: false},
]

// Setting Column들
export const SETTING_PACS_CONNECTION_COLUMN = [
  { id: "status", label: "Status", sortable: false},
  { id: "aetitle", label: "AE Title", sortable: false},
  { id: "description", label: "Description", sortable: false},
  { id: "ip", label: "Address", sortable: false},
  { id: "port", label: "Port", sortable: false},
  { id: "protocol", label: "Protocol", sortable: false},
  { id: "defaultServer", label: "Default Servers", sortable: false},
]

export const SETTING_PACS_CONNECTION_COLUMN_WITHOUT_STATUS = [
  { id: "description", label: "Description", sortable: false},
  { id: "ip", label: "Address", sortable: false},
  { id: "port", label: "Port", sortable: false},
  { id: "aetitle", label: "AE Title", sortable: false},
  { id: "protocol", label: "Protocol", sortable: false},
]

export const SETTING_ACCESS_CONTORL_COLUMN = [
  { id: "statusName", label: "Status", sortable: false},
  { id: "name", label: "Name", sortable: false},
  { id: "email", label: "Email", sortable: false},
  { id: "roleName", label: "Role", sortable: false},
  { id: "note", label: "Note", sortable: false},
]
